import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout";
import "./EventUploadForm.css";

const EventUploadForm = () => {
  const [name, setName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [image, setImage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !eventDate || !image) {
      toast.error("Please fill out all fields and upload an image.");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("event_date", eventDate);
    formData.append("image", image);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/events/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success("Event erfolgreich hochgeladen.");
        setName("");
        setEventDate("");
        setImage(null);
      } else {
        toast.error("Fehler beim Hochladen des Events.");
      }
    } catch (error) {
      console.error("Error uploading event:", error);
      toast.error("Fehler beim Hochladen des Events.");
    }
  };

  return (
    <Layout>
      <div className="Top">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          closeOnClick
          pauseOnHover
          style={{ width: "250px", fontSize: "14px" }}
        />
        <div className="upload-card">
          <h2 className="upload-card-title">Neues Event erstellen</h2>
          <form onSubmit={handleSubmit} className="upload-form">
            <div className="upload-form-group">
              <label>Event Name:</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="upload-form-group">
              <label>Event Datum:</label>
              <input
                type="date"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
                required
              />
            </div>
            <div className="upload-form-group">
              <label>Bild hochladen</label>
              <input
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
                accept="image/*"
                required
              />
            </div>
            <button type="submit" className="upload-button">
              Event erstellen
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default EventUploadForm;
